class Cart {
  constructor() {
    this.addColorFromStyles = this.addColorFromStyles.bind(this);
    this.initBehavior();
    this.showEBOForm();
  }

  isAddToCartPossible() {
    return $('.pc-Style').length;
  }

  initBehavior() {
    return $(document).on(
      'submit',
      'form.pc-Style-blanks',
      this.addColorFromStyles
    );
  }

  showEBOForm() {
    if (!this.isAddToCartPossible()) {
      return;
    }
    return undefined;
  }

  addColorFromStyles(event) {
    event.preventDefault();
    event.stopPropagation();
    const f = $(event.target);
    const id = $('.pc-Swatch.is-selected')[0].dataset.colorid;
    const size = f.find('#sizes').val();
    const qty = f.find('input[name=qty]').val();
    const messageField = $('.is-addBlankToCartMessage');
    messageField.text('');
    messageField.show();
    messageField.text('Added ' + qty + ' ' + size + ' to the cart');
    StyleBitz.Cart.addColor(id, size, qty);
    setTimeout(function() {
      messageField.fadeOut();
    }, 5000);
  }
}

jQuery(() => (ProductCatalog.Cart = new Cart()));
